import { FormEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { useDispatch } from "react-redux";
import { FormattedWorkflowConfiguration } from "@idw-types/data/workflow-configuration";
import { removeWorkflowConfiguration } from "@redux/actions/workflows-actions";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { deleteWorkflowRequest } from "@requests/service-configuration";

type DeleteVerificationWorkflowModalProps = {
    onModalClose: () => void;
    workflowConfiguration: FormattedWorkflowConfiguration;
};

export const DeleteVerificationWorkflowModal = (props: DeleteVerificationWorkflowModalProps) => {
    const dispatch = useDispatch();
    const { onModalClose, workflowConfiguration } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);
        const { data, error } = await deleteWorkflowRequest(workflowConfiguration.id);
        if (data) {
            displaySuccessModal(
                dispatch,
                resources.requests.deleteWorkflow.success.title,
                resources.requests.deleteWorkflow.success.message
            );

            dispatch(removeWorkflowConfiguration(workflowConfiguration));
            onModalClose();
        } else {
            if (error) {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.deleteWorkflow.error.title,
                    resources.requests.deleteWorkflow.error.message,
                    error
                );
            }
            setRequestInProgress(false);
        }
    };

    return (
        <DefaultModal
            automationId="delete-verification-workflow-modal"
            ariaLabelledBy="delete-verification-workflow-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"delete-verification-workflow-title"} closeButton>
                    <Modal.Title>{resources.modals.deleteVerificationWorkflow.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {resources.modals.deleteVerificationWorkflow.description}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <ButtonWithSpinner
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.modals.deleteVerificationWorkflow.buttons.deleteWorkflow.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};